import { Injectable, Injector } from '@angular/core';
import { BaseResourceService } from 'eddydata-lib';
import { AcaoGovernoAdicional } from 'projects/eddydata-lib/src/lib/entidade/planejamento/acao-governo-adicional.model';

@Injectable({
  providedIn: 'root'
})
export class AcaoGovernoAdicionalService extends BaseResourceService<AcaoGovernoAdicional> {

  constructor(
    protected injector: Injector
  ) {
    super(`acoes-adicionais`, injector);
  }
}
